import { useCallback } from "react";
import { ProjectApi } from "@api/project-api/project-api";
import { GUID } from "@faro-lotv/foundation";
import { RegistrationState } from "@faro-lotv/service-wires";
import { sentryCaptureError } from "@src/utils/sentry-utils";

export type ReturnFunction = (
  projectApiClient: ProjectApi,
  captureTreeRevisionId: GUID,
) => Promise<void>;

/** Sets revision as canceled. */
export function useCancelRevision(): ReturnFunction {

  return useCallback(
    async (
      projectApiClient: ProjectApi,
      captureTreeRevisionId: GUID
    ): Promise<void> => {
      try {
        await projectApiClient.updateRegistrationRevision({
          registrationRevisionId: captureTreeRevisionId,
          state: RegistrationState.canceled,
        });
      } catch (error) {
        // If it fails to set the revision as canceled only log the error but
        // don't show it to the user since this is not a critical step.
        sentryCaptureError({
          title: "RevisionError: Failed to set revision as canceled.",
          error,
        });
      }
    },
    []
  );
}
